import { useState } from "react";
import { Helmet } from "react-helmet-async";
import AdminShell from "@/web/components/admin/admin-shell";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/web/components/ui/table";
import { Badge } from "@/web/components/ui/badge";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/web/components/ui/sheet";
import { cn } from "@/lib/utils";

const STATUS_FILTERS = ["All", "Pending", "Paid", "Shipped", "Cancelled"];

export default function AdminOrders() {
  const [filter, setFilter] = useState("All");
  return (
    <>
      <Helmet><title>Orders · Admin | Cool Wave</title></Helmet>
      <AdminShell>
        <div className="mb-4 flex items-center gap-2 overflow-x-auto">
          {STATUS_FILTERS.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={cn(
                "rounded-full border px-3 py-1 text-sm",
                filter === f ? "border-brand bg-brand text-white" : "border-border text-body hover:border-brand"
              )}
            >
              {f}
            </button>
          ))}
        </div>
        <div className="rounded-md border border-border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Order</TableHead>
                <TableHead>Customer</TableHead>
                <TableHead>Total</TableHead>
                <TableHead>Status</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell colSpan={5} className="text-center text-sm text-body">No orders yet.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <Sheet>
          <SheetTrigger className="hidden">open</SheetTrigger>
          <SheetContent>
            <SheetHeader><SheetTitle>Order detail</SheetTitle></SheetHeader>
            <p className="mt-4 text-sm text-body">Order detail drawer ready for live orders.</p>
            <Badge className="mt-4">Stub</Badge>
          </SheetContent>
        </Sheet>
      </AdminShell>
    </>
  );
}
